var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"common-report qcentric-unit-turnover-view"},[_c('qcentris-unit-relation'),_c('qcentris-unit-allocation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }